import React, { createContext, useContext } from 'react';
import { Platform } from 'react-native';
import {
  useFonts,
  Inter_400Regular,
  Inter_500Medium,
  Inter_600SemiBold,
} from '@expo-google-fonts/inter';

interface FontContextType {
  fontsLoaded: boolean;
}

// On web, fonts are loaded via CSS @font-face in +html.tsx
// No need to wait for JS-based font loading
const FontContext = createContext<FontContextType>({ fontsLoaded: Platform.OS === 'web' });

export const FontProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // On web, fonts are preloaded via CSS - always consider them "loaded"
  // On native (iOS/Android), we still need to load fonts via useFonts
  const [nativeFontsLoaded] = useFonts(
    Platform.OS === 'web'
      ? {} // Don't load fonts on web - they're in CSS
      : {
          Inter_400Regular,
          Inter_500Medium,
          Inter_600SemiBold,
        }
  );

  // Web: always true (fonts defined in CSS)
  // Native: wait for fonts to load
  const fontsLoaded = Platform.OS === 'web' ? true : !!nativeFontsLoaded;

  return (
    <FontContext.Provider value={{ fontsLoaded }}>
      {children}
    </FontContext.Provider>
  );
};

export const useFontLoading = () => useContext(FontContext);
